<template>
  <div
    v-if="columns"
    :class="{ 'grid auto-cols-fr grid-flow-row justify-between md:grid-flow-col mobile:px-4': columns }"
  >
    <Category
      v-if="!mgnlProps.disableColumn1"
      :title="mgnlProps.tabTitle1"
      :categories="transformLinks(mgnlProps.categories1)"
    />
    <Category
      v-if="!mgnlProps.disableColumn2"
      :title="mgnlProps.tabTitle2"
      :categories="transformLinks(mgnlProps.categories2)"
    />
    <Category
      v-if="!mgnlProps.disableColumn3"
      :title="mgnlProps.tabTitle3"
      :categories="transformLinks(mgnlProps.categories3)"
    />
    <Category
      v-if="!mgnlProps.disableColumn4"
      :title="mgnlProps.tabTitle4"
      :categories="transformLinks(mgnlProps.categories4)"
    />
    <Category
      v-if="!mgnlProps.disableColumn5"
      :title="mgnlProps.tabTitle5"
      :categories="transformLinks(mgnlProps.categories5)"
    />
  </div>
</template>

<script lang="ts" setup>
import Category from './Categories.vue';
import { CategoriesBuilder, WrapperProps } from './Categories.model';

interface Category {
  key: string;
  id: string;
  name: string;
  categoryLink: string;
}

interface Link {
  type?: 'external' | 'download' | 'page';
  target?: '_parent' | '_top' | '_blank' | '_self';
  url?: string;
  name?: string;
  emphasis?: string;
  showLinkKiosk?: boolean;
  showLinkCatalog?: boolean;
}

const props = defineProps(WrapperProps);
const { $domain } = useNuxtApp();
const mgnlProps = {
  ...CategoriesBuilder.build(props),
  categories1: props.categoryLinks1 ? await JSON.parse(props.categoryLinks1) as Category[] : [],
  categories2: props.categoryLinks2 ? await JSON.parse(props.categoryLinks2) as Category[] : [],
  categories3: props.categoryLinks3 ? await JSON.parse(props.categoryLinks3) as Category[] : [],
  categories4: props.categoryLinks4 ? await JSON.parse(props.categoryLinks4) as Category[] : [],
  categories5: props.categoryLinks5 ? await JSON.parse(props.categoryLinks5) as Category[] : [],
};

const columns = computed((): number => {
  let count = 0;

  for (const key in props) {
    const value = (mgnlProps as any)[key];
    if (typeof value === 'boolean' && value === false) {
      count++;
    }
  }

  return count;
});
const transformLinks = (categories: Category[]) => {
  return categories.map((categoryLink) => {
    return {
      type: 'page',
      target: '_self',
      url: $domain.host == 'shop.kik.local.de' ? `http://${$domain.host}/${categoryLink.categoryLink}` : `https://${$domain.host}/${categoryLink.categoryLink}`,
      name: categoryLink.name,
      emphasis: '',
      showLinkKiosk: false,
      showLinkCatalog: false,
    } as Link;
  });
};
</script>
